module.exports = __webpack_public_path__ + "static/page-3-a08076f9f81f80caeb7a08046d28b3af.jpg";